import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'piqet-angular-add-product-use-impact',
  templateUrl: './add-product-use-impact.component.html',
  styleUrls: ['./add-product-use-impact.component.scss'],
})
export class AddProductUseImpactComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  productUseData: any;
  productUseForm!: FormGroup;
  productUseAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationlist: any;
  conversionList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveProductUseImpact = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService,
    private projectService: ProjectsService,
    private spinnerService: NgxSpinnerService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.productUseData = this.modal?.modalService?.config?.initialState?.['prodUseImpactData'];
    this.isDisabledDropDown = this.modalLabel == 'Review product use impact' ? true : false;

    const placeHolderOrganization = {
      name: 'All organizations',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.productUseData.organizationList
    );

    this.indicatorList = this.productUseData.indicatiorList;
    this.organizationlist = newOrganizationlist;
    this.conversionList = this.productUseData.convertingProcessItems;
    this.regionList = this.productUseData.regionItems;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.productUseData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.productUseForm = new FormGroup(form);
    this.productUseAddEditForm = this.formBuilder.group({
      conversion: [this.productUseData.convertingProcessId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [this.productUseData.organizationId || this.organizationlist[0] || null],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  setFormData() {
    this.productUseAddEditForm.patchValue({
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.productUseData?.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.productUseData?.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForRegion(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onChange(value: any) {
    this.productUseAddEditForm.controls['region'].reset();
    if (value?.id) {
      this.projectService.getRegionListProductUse(value.id).subscribe((res: any) => {
        this.regionData = res.data;
      });
    } else {
      this.regionData = [];
    }
  }

  onSave() {
    this.submitted = true;

    if (
      this.productUseAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'area-based-conversion' &&
        !this.productUseAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (this.productUseAddEditForm.status == 'VALID' && this.productUseForm.status == 'VALID') {
      const entires = Object.entries(this.productUseForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.productUseData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const conversionPayload = {
        convertingProcessId: this.productUseAddEditForm.controls['conversion'].value,
        regionId:
          this.productUseAddEditForm.controls['region'].value?.id || this.productUseData.regionId,
        organizationId:
          this.productUseAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.productUseAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.productUseAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveProductUseImpact.emit(conversionPayload);
      this.onClose();
    }
  }
}
